import { memo } from 'react';
import { RatingHour, RatingDay } from 'types/conditionRating';
import styles from './ConditionRatingsBars.module.scss';
import ConditionRatingsBar from './ConditionRatingsBar';

interface BarsProps {
  barHeight?: '4px' | '8px' | '10px' | '16px';
  bars: RatingDay;
  nextDayIndex?: number | undefined;
}

const ConditionRatingsBars: React.FC<BarsProps> = (props) => {
  const { bars, barHeight = '4px', nextDayIndex } = props;
  return (
    <div
      className={styles.wrapper}
      style={{ maxHeight: barHeight, minHeight: barHeight, marginRight: nextDayIndex ? '1px' : 0 }}
      data-testid="condition-ratings-bars"
    >
      {bars?.map((bar: RatingHour, barIndex: number) => {
        const nextConditions = bars[barIndex + 1]?.rating;
        return (
          bar && (
            <ConditionRatingsBar
              key={`condition-ratings-bar-${barIndex + 1}`}
              barLength={bars?.length}
              bar={bar}
              nextConditions={nextConditions}
              index={barIndex}
            />
          )
        );
      })}
    </div>
  );
};

export default memo(ConditionRatingsBars);
